





















































































































































































































































/* tslint:disable */
import { InfoState } from '@/core';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
// import { ColumnsAdjustRequestData, ColumnSortRequestData, PageNumberChangeRequestData, PageSizeChangeRequestData, PaginationConfig, SortedColumnInfo, TableColumnConfig, TableEntry } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { confirmService, ConfirmOptions, ConfirmButton } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
// import { CreateElement, VNode } from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { SwTable, TableEntry, TableColumnConfig,
PaginationConfig, PageNumberChangeRequestData, ColumnsAdjustRequestData,
PageSizeChangeRequestData, ColumnSortRequestData, SortedColumnInfo, TableFooterConfig, SwTableColumnSelection } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { CreateElement, VNode } from 'vue';
import { SwDropMenu, DropMenuItem } from '@libs-uuif/shared/sw-drop-menu';
import { DropdownLight } from '../../shared/dropdown-light';
import UUIFComponent from '@/shared/uuifComponent';
import { SwDatetimePicker, DateTimePickerConfig } from '@sonicwall/unified-ui-framework/src/shared/sw-datetime-picker';
import { SelectableDatesRangeType } from '@sonicwall/unified-ui-framework/src/shared/sw-datetime-picker/types';
import { SwExpandableTextfield, SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import MswAppTitle from "@/shared/msw-app-title/msw-app-title.vue";
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { SwRadio } from '@libs-uuif/shared/sw-radio';
import { ContentToolbarExpandFilterBlock, SwContentToolbar, SwContentToolbarExpand } from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import  ViewMoreDetailsComponent  from './components/viewMoreDetails.component.vue';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import SwTableBody from '@sonicwall/unified-ui-framework/src/shared/sw-table/sw-table-body.vue';
import {
  fetchCurrentDate,
  formatDate,
  FILTER_TYPES,
  CUSTOMIZED_COLUMNKEYS,
  RADIO_LISTS,
  LARGE_CUSTOMER_LISTS,
  LARGE_CUSTOMER_REQUEST_PARAMS,
} from './components/activity-logs.mappings';
import { RootStoreState } from '../../store/store';
import { Mutation, State } from 'vuex-class';
import { tooltip, TooltipDirValues } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';
import { SetHelpContentIdPayload } from '../../core/core.store';
import ExportcsvService from '@/shared/msw-exportcsv.service';
const cssPrefix = 'actvity-logs';

@Component({
  components: {
    ...UUIFComponent,
    SwTableColumnSelection,
    SwExpandableTextfield,
    SwDatetimePicker,
    DropdownLight,
    SwScrollView,
    MswAppTitle,
    SwTextfield,
    SwCheckbox,
    SwDropMenu,
    SwSelect,
    ViewMoreDetailsComponent,
    SwTable,
    SwRadio,
    SwIcon,
    
  },
  directives:{
    tooltip,
  },
})
export default class  ActivityLogsComponent extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @State((state: RootStoreState) => state.ActivityLogsStoreModule.activityDetails)
  readonly activityDetails: any[];

  @State((state: RootStoreState) => state.ActivityLogsStoreModule.activityTotalRecords)
  readonly activityTotalRecords: number;

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;

  menuOpened: boolean = false;
  selectedMenuItem: string = '';
  serialNumberFilterMenuOpened: boolean = false;
  selectedSerialNumberMenuItem: string = '';
  searchValue: any = '';
  search: any = '';
  menuItems: DropMenuItem[] = [];
  textExpanded : boolean = false;
  apiResponse: any = [];
  isParent = true;
  deleteReason: string = '';
  showDeleteReasonModal: boolean = false;
  isExpandSearchFilter: boolean = false;
  activitylogsevent = 'All';
  tenantsSelectedForFilter = '';
  sourcesFilter = '';
  usersFilter = '';
  organizationFilter = '';
  activitylogseventoptions: SelectOption[] = [];
  serialNumberOptions: SelectOption[] = [];
  tenantOptions: SelectOption[] = [];
  sourcesOptions: SelectOption[] = [];
  usersOptions: SelectOption[] = [];
  activityIpOptions: SelectOption[] = [];
  organizationsOptions: SelectOption[] = [];
  moreFiltersVisibility: boolean = false;
  customColumnsCheckboxVisibility: boolean = false;
  selectedColumnKeys: string[] = [];

  // DATE TIME PICKER
  activityTimeRange = '';
  activityName = '';
  shouldCallAPI: boolean = false;
  dtRangeValue: string = '01/01/2022->30/01/2022';
  dtRangeValue2: string = '01/01/2022->30/01/2022';
  prevDatePicked: string = '';
  dateRangeType: string = 'days30';
  selectableDatesRange : SelectableDatesRangeType = {};
  dateValue: string = '';
  datePicker: DateTimePickerConfig = {
    type: 'date',
    placeholder: 'Select date range',
    dateFormat: 'DD/MM/YYYY',
    pane: 2,
    enableRange: true,
    selectableDatesRange : this.getSelectableDatesRange,
  };

  // TABLE STUFF STARTS
  tableData: TableEntry[] = [];
  tableColConfig: TableColumnConfig[] = [];
  sortedColumns: SortedColumnInfo[] = [];
  basicColumnsConfig: TableColumnConfig[] = [];
  isLoadingPartialDataset: boolean = false;
  partialDatasetPaginationConfig: PaginationConfig = {
    pageNumber: 1,
    pageSize: 50,
    datasetOffset: 0,
  };
  selectedUserId: any = '';
  userDetailModal: boolean = false;
  deleteSubscriptionName: any = '';
  deleteSubscriptionID: any = '';
  subscriptionEndDate: any = '';
  cancelDate: any = '';

  isNoSubscriptions: boolean = false;
  filters: any = {};
  datePicked: string = '';
  tenantList = new Map();

  adjustedColumns: ColumnsAdjustRequestData = {};
  expandVisible: boolean = false;
  allFilters: any[]=[];
  filtersSelected: any[] = [];
  moreFiltersSelected = new Map();
  filterBlockGridList: ContentToolbarExpandFilterBlock[][] = [
    [
      ...this.morefilters,
    ]];
  checkboxOptionsList: any[] = [];
  pickedActivityType: string = '';
  activityNameSearchFilter: string = '';
  activityNamesCheckbox: any = [];
  showMoreDetails: boolean = false;
  showMoreData: any = {};

  activityTypeList: any[] = [];
  selectedActivityType: string = 'All';
  selectedActivityName: string = 'All';
  blockScrolling:boolean = false;
  filtertypes: string[] = [...FILTER_TYPES];
  customizedColumnKeys: string[] = [...CUSTOMIZED_COLUMNKEYS];
  todaysDate: Date;
  last30DaysDate: Date;
  last1yearDate: Date;
  isLargeCustomerMode: boolean = false;
  iconColor: string = '#333';
  largeCutomerMapping :{[property: string]: string} = {...LARGE_CUSTOMER_REQUEST_PARAMS};
  isLargeCustomerFIlterList: string[] =  [...LARGE_CUSTOMER_LISTS];

  get getActivityTypesValues() {
    let activityTypes: SelectOption[] = [];
    this.activityTypeList &&
    this.activityTypeList.length > 0 &&
    this.activityTypeList.map((ele) => {
      activityTypes.push({
        label: ele.operationTypeDisplayText,
        value: ele.operationType,
        id: ele.operationType,
      });
    });
    return activityTypes;
  }

  get getActivityNamesValues() {
    let activityNames: SelectOption[] = [];
    this.activityTypeList &&
    this.activityTypeList.length > 0 &&
    this.activityTypeList.map((ele) => {
      if (ele.operationType === this.selectedActivityType) {
        ele.operationsList.forEach((activity: any) => {
          activityNames.push({
            label: activity.operationId === 0 ? 'All' : activity.operationDisplayName,
            value: activity.operationName.toString(),
            id: activity.operationName.toString(),
          });
        });
      }
    });
    return activityNames;
  }
  get getTableHeight() {
    let remainsTableHeight = 200;
    if (this.expandVisible) {
      remainsTableHeight = 430;
    }
    return remainsTableHeight;
  }
  onChangeActivityType() {
    this.selectedActivityName = 'All';
    this.filters['operationType'] = this.selectedActivityType;
    this.filters['operationName'] = this.selectedActivityName;
  }

  onChangeActivityName(value: any) {
    this.filters['operationName'] = value;
  }
  onDateOptionsChange(value: string) {
    this.setupDate();
    const currentDate = value === 'custom' ? this.dtRangeValue2 : this.dtRangeValue;
    let fromdate: any = currentDate.split('->')[0].split('/');
    let todate: any = currentDate.split('->')[1].split('/');
    fromdate = `${fromdate[1]}/${fromdate[0]}/${fromdate[2]}`;
    todate = `${todate[1]}/${todate[0]}/${todate[2]}`;
    this.filters['fromdate'] = fromdate;
    this.filters['todate'] = todate;
  }
  get isPageLoading(): boolean {
    return this.$store.getters.loading;
  }

  get filterBlockGrid() : ContentToolbarExpandFilterBlock[][] {
    return [[
      ...this.morefilters,
    ]];
  }

  get getTableFooterConfig() : TableFooterConfig {
    const tableFooterConfig: TableFooterConfig = {
      render: (h: CreateElement) => {
        return (
          <div style="padding:10px; font-weight:700"> { `${(this.$t('activityLogs.totalRecords').toString())} : ${this.activityTotalRecords}` }  </div>
        ) as VNode;
      },
    };
    return tableFooterConfig;
  }

  get getBasicColumnsConfig(): TableColumnConfig[] {
    return this.tableColConfig.filter((column: TableColumnConfig) => {
      return this.customizedColumnKeys.includes(column.key);
    });
  }

  get moreFilterSelectedGetter() {
    return this.moreFiltersSelected;
  }

  get getSelectedColumnKeys() {
    return this.selectedColumnKeys;
  }

  onSelectColumns(selectedColumns: string[]) {
    this.updateIpAddressFiltersData(selectedColumns);
    this.selectedColumnKeys = [...selectedColumns];
  }

  updateIpAddressFiltersData(selectedColumns: string[]) {
    const ipMapFlag: string = 'activityIpList';
    const ipParamsFlag: string = 'ipAddress';
    if (selectedColumns.includes(ipParamsFlag)) {
      if (!this.getFiltertypes.includes(ipMapFlag)) {
        this.filtertypes.push(ipMapFlag);
        this.allFilters.push({
          id: ipMapFlag.toString(),
          label: ipMapFlag.toUpperCase(),
          value: ipMapFlag,
        });
        this.moreFiltersSelected.set(ipMapFlag, {
          mode: 'radio',
          textField: '',
          radioFilterList: this.matchFilterNames(ipMapFlag),
          radioSelected: '',
        });
        this.moreFiltersSelected = new Map(this.moreFiltersSelected);
      }
    } else {
      if (this.getFiltertypes.includes(ipMapFlag)) {
        this.filtertypes = this.filtertypes.filter((ele: any) => ele !== ipMapFlag);
        this.removeFilter(ipMapFlag);
        this.allFilters = this.allFilters.filter((filterConfig: any) => {
          return filterConfig.id !== ipMapFlag;
        });
        this.moreFiltersSelected.delete(ipMapFlag);
        this.moreFiltersSelected = new Map(this.moreFiltersSelected);
      }
    }
  }

  clearFilters() {
    this.getAllFilters &&
    this.getAllFilters.length > 0 &&
    this.getAllFilters.forEach((filter: any) => {
      if (filter.value !== 'operationTypes') {
        if (this.moreFiltersSelected.get(filter.value)) {
          if (this.moreFilterSelectedGetter.get(filter.value).mode === 'radio') {
            this.moreFilterSelectedGetter.get(filter.value).radioSelected = ''
          } else {
            this.moreFiltersSelected.get(filter.value).checkboxesSelected = [];
          }
          this.moreFiltersSelected.get(filter.value).textField = '';
        }
        this.removeFilter(filter.value);
      }
    });
    this.moreFiltersSelected = new Map(this.moreFiltersSelected);
    this.resetTableConfigs();
    this.makeTableData();
    this.$forceUpdate();
  }

  get getAllFilters() {
    return this.allFilters;
  }

  get morefilters() {
    let morefilter: ContentToolbarExpandFilterBlock[] = [];
    this.getAllFilters &&
    this.getAllFilters.length > 0 &&
    this.getAllFilters.map((item: any, index: number) => {
      morefilter.push({
        title: this.mapFilterNames(item.value)?.header || '',
        content: (h: CreateElement) => { // tslint:disable-line
            let nodes: VNode[] = [];
            nodes = [(
              <div class={['sw-flexbox__flex']}>
                <div class={`${cssPrefix}__searchcontainerWrapper`} style="margin-bottom: 15px;">
                  <div class={`${cssPrefix}__searchcontainerWrapper--inner`}>
                  <SwTextfield
                    class={`${cssPrefix}__searchcontainer  ${this.isLargeCustomer(item.value) ? 'addPadding': ''}`}
                    props-name="searchFilter"
                    props-placeholder={this.isLargeCustomer(item.value) ? `${this.$t('activityLogs.largecustomersearchPlaceholder')}` : (this.mapFilterNames(item.value)?.placeholder || '')}
                    props-value={this.moreFilterSelectedGetter.get(item.value)?.textField || ''}
                    on-input={(e: any) => {
                      this.onTypeInput(item.value, e);
                    }}
                    full/>
                  { this.isLargeCustomer(item.value) &&
                    <div
                      class={`${cssPrefix}__searchIcon`}
                      onClick={(e: any) => {
                        this.onSearchSubFilters(item.value);
                      }}>
                      <SwIcon
                        props-name="search"
                        props-size="medium"
                        props-color={this.iconColor}>
                      </SwIcon>
                    </div>
                  }
                </div>
                { this.isClearSelectionActivated(item.value) &&
                  <div  class={`${cssPrefix}__clearIcon`}
                    onClick={() => { this.clearSelection(item.value)}}>
                   <SwIcon
                    props-name="clear"
                    props-size="medium"
                    props-color={this.iconColor}>
                  </SwIcon>
                  </div> }
                </div>
              <div class={`${cssPrefix}__checkboxescontainer`}>{ [].concat(...this.moreFilterSelectedGetter.get(item.value).checkboxFilterList || [],
                ...this.moreFilterSelectedGetter.get(item.value).radioFilterList || [])
                .filter((option: any, index: number) => {
                  return option.label.toLowerCase().indexOf(this.moreFilterSelectedGetter.get(item.value).textField.toLowerCase()) > -1 ||
                    (this.moreFilterSelectedGetter.get(item.value).mode === 'checkbox'  && this.moreFilterSelectedGetter.get(item.value).checkboxesSelected.includes(option.value) ||
                    this.moreFilterSelectedGetter.get(item.value).mode === 'radio'  && this.moreFilterSelectedGetter.get(item.value).radioSelected === option.value);
                })
                .map((element: any, index: number) => {
                  return (
                    <div key={index} class={`${cssPrefix}__checkboxes`}>
                     { this.moreFilterSelectedGetter.get(item.value).mode === 'radio' ?
                      <SwRadio
                        {...{
                          props: {
                            name : `${element.value}radio`,
                            value : element.value,
                            pickedValue : this.moreFilterSelectedGetter.get(item.value).radioSelected,
                          },
                          nativeOn: {
                            change: (event : any) => {
                              const clickedValue = event.target.value;
                              this.moreFiltersSelected.get(item.value).radioSelected = clickedValue.toString();
                              this.moreFiltersSelected = new Map(this.moreFiltersSelected);
                              this.makeCSVAndUpdateTable([this.moreFiltersSelected.get(item.value).radioSelected], item.value);
                            },
                          },
                        }}>
                        <div class={`${cssPrefix}__optionLabelClass`}>
                          { element.label.length > 20 ? <span  title={element.label}>  { `${element.label.toString().substring(0,20)}...` } </span>
                           : <span>  { element.label } </span> }
                        </div>
                      </SwRadio> :
                      <SwCheckbox
                        name="filtercheckbox"
                        props-value={element.value}
                        props-checked={this.moreFilterSelectedGetter.get(item.value).checkboxesSelected.includes(element.value)}
                        on-change={() => {
                          if (this.moreFilterSelectedGetter.get(item.value).checkboxesSelected.includes(element.value)) {
                            this.moreFiltersSelected.get(item.value).checkboxesSelected.splice(this.moreFiltersSelected.get(item.value).checkboxesSelected.indexOf(element.value), 1)
                            this.moreFiltersSelected = new Map(this.moreFiltersSelected);
                            this.makeCSVAndUpdateTable(this.moreFiltersSelected.get(item.value).checkboxesSelected, item.value);
                          } else {
                            this.moreFiltersSelected.get(item.value).checkboxesSelected.push(element.value)
                            this.moreFiltersSelected = new Map(this.moreFiltersSelected);
                            this.makeCSVAndUpdateTable(this.moreFiltersSelected.get(item.value).checkboxesSelected, item.value);
                          }
                        }}>
                        <div class={`${cssPrefix}__optionLabelClass`}>
                         { element.label.length > 20 ? <span title={element.label}>  { `${element.label.toString().substring(0,20)}...` } </span>
                           : <span>  { element.label } </span> }
                        </div>
                        </SwCheckbox>}
                    </div>
                  )
                })
              }</div>
            </div> as VNode)];
            return nodes
            },
            width: this.getToolBarWidth,
          }
        )
      }
    )
    return morefilter;
  }

  isLargeCustomer(value: string) {
    return this.isLargeCustomerMode && this.isLargeCustomerFIlterList.includes(value);
  }

  onTypeInput(itemValue: string, text:string) {
    this.moreFiltersSelected.set(itemValue, {
      ...this.moreFiltersSelected.get(itemValue),
      textField: text,
    });
    this.moreFiltersSelected = new Map(this.moreFiltersSelected);
  }

  isClearSelectionActivated(itemValue: string) {
    if (this.moreFilterSelectedGetter.get(itemValue).mode === 'radio') {
      return this.moreFilterSelectedGetter.get(itemValue).radioSelected &&
        this.moreFiltersSelected.get(itemValue).radioSelected !== '' &&
        this.isLargeCustomer(itemValue);
    } else {
      return this.moreFilterSelectedGetter.get(itemValue).checkboxesSelected &&
        this.moreFiltersSelected.get(itemValue).checkboxesSelected.length > 0 &&
        this.isLargeCustomer(itemValue);
    }
  }

  clearSelection(itemValue: string) {
    if (this.moreFilterSelectedGetter.get(itemValue).mode === 'radio') {
      if (this.moreFilterSelectedGetter.get(itemValue).radioSelected) {
        this.moreFiltersSelected.get(itemValue).radioSelected = '';
      }
    } else {
      if (this.moreFilterSelectedGetter.get(itemValue).checkboxesSelected) {
        this.moreFiltersSelected.get(itemValue).checkboxesSelected = [];
      }
    }
    this.moreFiltersSelected = new Map(this.moreFiltersSelected);
    this.removeFilter(itemValue);
    // this.resetTableConfigs();
    // this.makeTableData();
  }

  async onSearchSubFilters(itemValue: any) {
    const keyword = this.moreFiltersSelected.get(itemValue).textField || '';
     if (itemValue === 'serialList' && (keyword.length < 12 || keyword.length > 12)) {
      const message: InfoState = { infoType: 'high', infoMsg: 'Invalid Serial Number' };
      this.$store.commit('enqueueMessage', message);
      return;
    }
    if (this.isLargeCustomerMode && keyword) {
      await this.fetchActivitySubFiltersForLargeCustomers(itemValue, keyword);
    }
  }

  async fetchActivitySubFiltersForLargeCustomers(filterName: string, searchedKey: string) {
    const filterFlag = this.largeCutomerMapping[filterName];
    const request = {
      [filterFlag]: searchedKey,
    };
    this.$store.dispatch('ActivityLogsStoreModule/fetchActivitySubFilters', request)
      .then((resp: any) => {
        if (resp.msgCode === 'MSWAPP:SUCCESS') {
          this.updateFilters(resp.content.filterList, filterName);
        } else {
          const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc || 'Operation is unsuccessfull.' };
          this.$store.commit('enqueueMessage', message);
        }
        this.$store.commit('stopLoading');
      });
  }

  updateFilters(lists: any, filterName: string) {
    const { tenantsList, serialList, usersList } = lists;
    switch(filterName) {
      case 'serialList': this.makeSerialNumberList(serialList);
      case 'tenantsList': this.makeTenantList(tenantsList);
      case 'usersList': this.makeUsersList(usersList);
      default: '';
    }
    this.getAllFilters &&
    this.getAllFilters.length > 0 &&
    this.getAllFilters.forEach((filter: any) => {
      if (filter.value === filterName) {
        if (this.moreFiltersSelected.get(filter.value)) {
          const subFilters = this.matchFilterNames(filterName) || [];
          if (this.moreFilterSelectedGetter.get(filter.value).mode === 'radio') {
            this.moreFilterSelectedGetter.get(filter.value).radioFilterList = subFilters ? subFilters : []
          } else {
            this.moreFiltersSelected.get(filter.value).checkboxFilterList = subFilters ? subFilters : [];
          }
          this.moreFiltersSelected.get(filter.value).textField = '';
        }
      }
    });
    this.moreFiltersSelected = new Map(this.moreFiltersSelected);
  }

  mapFilterNames(filter: any) {
    switch(filter) {
      case 'tenantsList': return { header: (this.$t('activityLogs.tenants').toString()), placeholder: (this.$t('activityLogs.placeholder1').toString()) };
      case 'sourceList': return { header: (this.$t('activityLogs.sources').toString()), placeholder: (this.$t('activityLogs.placeholder2').toString()) };
      case 'usersList': return { header: (this.$t('activityLogs.users').toString()), placeholder: (this.$t('activityLogs.placeholder3').toString()) };
      case 'serialList': return { header: (this.$t('activityLogs.serNums').toString()), placeholder: (this.$t('activityLogs.placeholder4').toString()) };
      case 'organizationsList': return { header: (this.$t('activityLogs.organizations').toString()), placeholder: (this.$t('activityLogs.placeholder5').toString()) };
      case 'activityIpList': return { header: (this.$t('activityLogs.ip').toString()), placeholder: (this.$t('activityLogs.placeholder6').toString())};
      default:  return { header: '', placeholder: '' };
    }
  }
  get getToolBarWidth() {
    let width: number = 250;
    if ((this.$refs["tableToolBar"] as HTMLDivElement)) {
      width = Math.floor((+(this.$refs["tableToolBar"] as HTMLDivElement).clientWidth) / this.getFiltertypes.length) || 250;
    }
    return width;
  }

  get getFiltertypes() {
    return this.filtertypes;
  }

  onToggleFilterExpand() {
    this.expandVisible = !this.expandVisible;
  }

  onApplyFilers() {
    const basicfilters: any[] = Object.keys(this.filters);
    const filtersFlags: any[] = this.filtertypes.map(ele => this.filterNameConverter(ele));
    if (basicfilters.filter(ele => filtersFlags.includes(ele)).length > 0 || this.isLargeCustomerMode) {
      this.resetTableConfigs();
      this.makeTableData();
    }
    this.expandVisible = false;
  }

  onDateRangeSelect(dateRange: any) {
    let fromdate = dateRange.split('->')[0].split('/');
    let todate = dateRange.split('->')[1].split('/');
    fromdate = `${fromdate[1]}/${fromdate[0]}/${fromdate[2]}`;
    todate = `${todate[1]}/${todate[0]}/${todate[2]}`;
    const defaultDateRange = `${formatDate(this.last30DaysDate.toDateString())}->${formatDate(this.todaysDate.toDateString())}`;
    if ((new Date(todate) > this.todaysDate)) {
      this.dtRangeValue2 = defaultDateRange;
      const message: InfoState = { infoType: 'high', infoMsg: 'Selected date(s) cannot exceed current date' };
      this.$store.commit('enqueueMessage', message);
      this.handleoutsideClickDate();
    } else if (this.checkifDateRangeExceedsDays(fromdate, todate, 30)) {
      this.dtRangeValue2 = defaultDateRange;
      const message: InfoState = { infoType: 'high', infoMsg: 'Selected Date Range cannot exceed 30days' };
      this.$store.commit('enqueueMessage', message);
      this.handleoutsideClickDate();
    } else {
      this.filters['fromdate'] = fromdate;
      this.filters['todate'] = todate;
    }
  }

  applyFilter() {
    this.resetTableConfigs();
    this.makeTableData();
  }

  filterNameConverter(filter: string = '') {
    switch(filter) {
      case 'tenantsList': return 'tenantId';
      case 'sourceList': return 'source';
      case 'usersList': return 'username';
      case 'serialList': return 'serialNumber';
      case 'organizationsList': return 'orgId';
      case 'activityIpList': return 'ipAddress';
      default: return 'operation';
    }
  }

  makeCSVAndUpdateTable(list: any[], filter: string) {
    let csvString = '';
    list.forEach((element: any, index: number) => {
      if(index > 0) {
        csvString = `${csvString},${element}`;
      } else {
        csvString = `${element}`;
      }
    });
    this.filters[this.filterNameConverter(filter)] = csvString;
  }

  removeFilter(filter: string) {
    if (this.filters[this.filterNameConverter(filter)]) {
      delete this.filters[this.filterNameConverter(filter)];
    }
  }

  onRequestAdjustColumns(data: ColumnsAdjustRequestData) {
    this.adjustedColumns = data;
  }

  onRequestSorting(data: ColumnSortRequestData) {
    if (!this.isLoadedAllActivityLogs) {
      this.partialDatasetPaginationConfig.pageSize = this.activityTotalRecords;
      this.$store.commit('ActivityLogsStoreModule/setActivityDetails', []);
      this.makeTableData(true)
    }
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  exportExcel() {
    const excelList: any = [];
    let column:any[] = [];
    column.push('CUSTOMER NAME');
    column.push('SUBSCRIPTION NAME');
    column.push('PO NUMBER');
    column.push('ESTATUS');
    column.push('EFFECTIVE DATE');
    column.push('VERSION');
    column.push('CURRENT TERM');
    column.push('RENEWAL TERM');
    excelList.push(column);
    column = [];
    for (const headers of this.tableData) {
      column.push(headers.customerName);
      column.push(headers.secaasSubscriptionId);
      column.push(headers.subscriptionName);
      column.push(headers.poNumber);
      column.push(headers.status);
      column.push(headers.version);
      column.push(headers.currentTerm);
      column.push(headers.renewalTerm);
      excelList.push(column);
      column = [];
    }
    const csvContent = ''.concat(excelList.map((e:any) => e.join(','))
    .join('\n'));
    const blob = new Blob([(csvContent)]);
    const link:any = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'Subscriptions.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
  }

  get getData(): TableEntry[] {
    return this.tableData;
  }

  get isLoadedAllActivityLogs(): boolean {
    return this.tableData?.length === this.activityTotalRecords;
  }

  async makeTableData(isLazyLoading: boolean = false) {
    let tableDataT: any[] = [];
    this.blockScrolling = true;
    if (!isLazyLoading) {
      this.setTotalDataSize(50);
    }
    const payload = {
      ...this.filters,
      pageSize: this.partialDatasetPaginationConfig.pageSize,
      pageNumber: this.partialDatasetPaginationConfig.pageNumber,
    };
    await this.$store.dispatch('ActivityLogsStoreModule/getUserDetails', payload)
      .then((resp) => {
        if (resp.msgCode === 'MSWAPP:SUCCESS' && resp.operationStatus === 'OK') {
          const activityDetails: any[] = [...this.activityDetails, ...resp.actiondetails];
          this.$store.commit('ActivityLogsStoreModule/setActivityDetails', activityDetails);
          this.$store.commit('ActivityLogsStoreModule/setActivityTotalRecords', resp.totalProducts);
          try {
            tableDataT = [...activityDetails];
            const tableData: TableEntry[] = tableDataT.map((el: any, index: any) => {
              return {
                ...el,
                _viewDetail: false,
                _showSerialFilter: false,
                _showTenantFilter: false,
                _showSourceFilter: false,
                _key: index,
              };
            });
            this.tableData = tableData;
            this.$nextTick(() => {
              this.updateScroll();
            });
            this.$store.commit('stopLoading');
          } catch (e) {
            this.tableData = [];
            const activityDetails = [...this.activityDetails];
            this.$store.commit('ActivityLogsStoreModule/setActivityDetails', activityDetails);
            this.$store.commit('stopLoading');
          }
        } else {
          if (!isLazyLoading) {
            this.tableData = [];
            const activityDetails: any[] = [];
            this.$store.commit('ActivityLogsStoreModule/setActivityDetails', activityDetails);
            this.$store.commit('ActivityLogsStoreModule/setActivityTotalRecords', 0);
            this.partialDatasetPaginationConfig.pageNumber = 1;
          } else {
            this.partialDatasetPaginationConfig.pageNumber = this.partialDatasetPaginationConfig.pageNumber - 1;
            this.$nextTick(() => {
              this.updateScroll();
            });
          }
          this.$store.commit('stopLoading');
        }
        if (this.isLoadingPartialDataset) this.isLoadingPartialDataset = false;
        if (this.blockScrolling) this.blockScrolling = false;
      })
      .catch((error: any) => {
        if (this.isLoadingPartialDataset) this.isLoadingPartialDataset = false;
        if (this.blockScrolling) this.blockScrolling = false;
        if (!isLazyLoading) {
          this.tableData = [];
          const activityDetails: any[] = [];
          this.$store.commit('ActivityLogsStoreModule/setActivityDetails', activityDetails);
          this.$store.commit('ActivityLogsStoreModule/setActivityTotalRecords', 0);
          this.partialDatasetPaginationConfig.pageNumber = 1;
        } else {
          this.partialDatasetPaginationConfig.pageNumber = this.partialDatasetPaginationConfig.pageNumber - 1;
        }
        this.$store.commit('stopLoading');
      });
  }
  get gettableColConfig () {
    return this.tableColConfig.filter(col => (this.selectedColumnKeys.includes(col.key)));
  }
  makeTableConfig() {
    const makeElipsis = (item: string = '', size = 20) => {
      if (item.length > size) {
        return `${item.slice(0, size)}...`;
      } return item;
    }
    this.tableColConfig = [
      {
        key: 'actiontime',
        dataKey: 'actiontime',
        title: (this.$t('activityLogs.activatyTime').toString()),
        width: 130,
        // sorter: true,
        sorter: (a: any, b: any) => {
          return a.actiontime - b.actiontime;
        },
        className: `${cssPrefix}__dataEntry`,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div v-tooltip={{ placement: 'top', persistent: false, compact: true, content: data.entry.actiontime }}>
              {data.entry.actiontime}
            </div>
          ) as VNode;
        },
      },
      {
        key: 'activityuserfullname',
        dataKey: 'activityuserfullname',
        title: (this.$t('activityLogs.activityUserName').toString()),
        sorter: true,
        width: 160,
        className: `${cssPrefix}__dataEntry`,
        tooltip: {
          content: 'User',
          compact: true,
        },
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div v-tooltip={{ placement: 'top', persistent: false, compact: true, content: data.entry.userfullname }}>
                {data.entry.activityuserfullname}
            </div>
          ) as VNode;
        },
      },
      {
        key: 'activityUserEmailAddresss',
        dataKey: 'activityUserEmailAddresss',
        title: (this.$t('activityLogs.email').toString()),
        className: `${cssPrefix}__dataEntry`,
        sorter: true,
        width: 180,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div style="width: 100%;" v-tooltip={{ placement: 'top', persistent: false, compact: true, content: `${(this.$t('activityLogs.userEmail').toString())}: ${data.entry.emailAddresss}` }}>
              <span>{ data.entry.activityUserEmailAddresss }</span>
            </div>
          ) as VNode;
        },
      },
      {
        key: 'operationDisplayText',
        dataKey: 'operationDisplayText',
        title: (this.$t('activityLogs.activity').toString()),
        className: `${cssPrefix}__dataEntry`,
        sorter: true,
        width: 150,
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div class={`filter_holder`} style="width: 100%;" v-tooltip={{ placement: 'top', persistent: false, compact: true, content: `${(this.$t('activityLogs.activity').toString())}: ${data.entry.operationDisplayText}` }}>
              <span>{ data.entry.operationDisplayText }</span>
            </div>
          ) as VNode;
        },
      },
      {
        key: 'operationDetail',
        dataKey: 'operationDetail',
        title: (this.$t('activityLogs.activityDetails').toString()),
        sorter: true,
        scalable: true,
        tooltip: {
          content: (this.$t('activityLogs.activityDetails').toString()),
          compact: true,
        },
        width: 250,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => { // tslint:disable-line
        return (
          <div class="last_col_actions">
            { data.entry.showdetailsLink === 'YES' ?
              <span  class="last_col_actions__inner">
                <span class="last_col_actions__inner--text"  style="font-size: 10px;"   v-tooltip={{ content: data.entry.operationDetail, compact: true }}>
                  {`${data.entry.operationDetail ? makeElipsis(data.entry.operationDetail, 50) : ''}` }
                </span>
                <a style="font-size: 10px;"
                   v-tooltip={{ content: (this.$t('activityLogs.clickHere').toString()), compact: true }}
                   onClick={() => { this.loadDetail(data.entry); }}>
                    {  `${data.entry.viewMoreText}` }
                </a>
              </span> :
              <span class="last_col_actions__inner" style="font-size: 10px;"  v-tooltip={{ content: data.entry.operationDetail, compact: true }}>
                { data.entry.operationDetail ? makeElipsis(data.entry.operationDetail, 50) : '' }
              </span>}
          </div>) as VNode;
        },
      },
      {
        key: 'tenant',
        dataKey: 'tenant',
        title: (this.$t('activityLogs.tenant').toString()),
        className: `${cssPrefix}__dataEntry`,
        scalable: true,
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div  style="width: 100%;" v-tooltip={{ placement: 'top', persistent: false, compact: true, content: `${(this.$t('activityLogs.tenant').toString())}: ${data.entry.tenant}` }}>
              {data.entry.tenant ?
              <span class={`filter_holder`}>
                <span>{ makeElipsis(data.entry.tenant, 8) }</span>
              </span>
              :<span></span>}
            </div>
          ) as VNode;
        },
        sorter: true,
        width: 120,
      },
      {
        key: 'serialNumber',
        dataKey: 'serialNumber',
        className: `${cssPrefix}__dataEntry`,
        title: (this.$t('activityLogs.serNum').toString()),
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div style="width: 100%;" v-tooltip={{ placement: 'top', persistent: false, compact: true, content: `${(this.$t('activityLogs.serNum').toString())}: ${data.entry.serialNumber}` }}>
              { data.entry.serialNumber &&
              <span class={`filter_holder`}>
                <span>{ data.entry.serialNumber }</span>
              </span>}
            </div>
          ) as VNode;
        },
        sorter: true,
        width: 150,
      },
      {
        key: 'sourceDisplayText',
        dataKey: 'sourceDisplayText',
        title: (this.$t('activityLogs.source').toString()),
        className: `${cssPrefix}__dataEntry`,
        sorter: true,
        tooltip: {
          content: (this.$t('activityLogs.sourceApp').toString()),
          compact: true,
        },
        width: 140,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div class={`filter_holder`} style="width: 100%;" v-tooltip={{ placement: 'top', persistent: false, compact: true, content: `${(this.$t('activityLogs.sourceApp').toString())}: ${data.entry.source}` }}>
              { data.entry.sourceDisplayText &&
              <span class={`filter_holder`}>
                <span>{ data.entry.sourceDisplayText }</span>
              </span>}
            </div>
          ) as VNode;
        },
      }, {
        key: 'activityOrganization',
        dataKey: 'activityOrganization',
        className: `${cssPrefix}__dataEntry`,
        title: (this.$t('activityLogs.userOrg').toString()),
        width: 150,
      }, {
        key: 'ipAddress',
        dataKey: 'ipAddress',
        title: (this.$t('activityLogs.ip').toString()),
        className: `${cssPrefix}__dataEntry`,
        sorter: true,
        width: 100,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div style="width: 100%;" v-tooltip={{ placement: 'top', persistent: false, compact: true, content: `${(this.$t('activityLogs.ip').toString())}: ${data.entry.ipAddress}` }}>
              { data.entry.ipAddress }
            </div>
          ) as VNode;
        },
      },
    ];
  }

  closeMenu() {
    this.selectedMenuItem = '';
    this.searchValue = '';
    this.partialDatasetPaginationConfig.pageNumber = 1;
    this.selectedActivityType = this.selectedActivityName  = 'All';
    this.filters['operationType'] = this.selectedActivityType;
    this.filters['operationName'] = this.selectedActivityName;
    this.makeTableData();
  }

  onCloseDialog() {
    this.showMoreDetails = false;
  }

  get getSelectableDatesRange() {
    return this.selectableDatesRange;
  }

  loadDetail(entry: any) {
    this.$store.dispatch('ActivityLogsStoreModule/getCompleteDetails', entry.activitydetailsid)
      .then((resp: any) => {
        if (resp.msgCode === 'MSWAPP:SUCCESS') {
          this.showMoreData = resp?.content?.activityCompleteDetailList || [];
          this.showMoreData = this.showMoreData.length > 0 &&
            this.showMoreData.map((activity: any) => {
              return {
                tableHeader: activity?.strTableTitle || '',
                colList: activity?.activityDetailsColList || [],
                tableData: activity?.operationsDetailList || [],
              };
            }) || [];
          this.showMoreDetails = true;
        } else {
          const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
          this.$store.commit('enqueueMessage', message);
        }
        this.$store.commit('stopLoading');
      })
      .catch((errorResponse: any) => {
        const message: InfoState = { infoType: 'high', infoMsg: errorResponse.msgDesc };
        this.$store.commit('enqueueMessage', message);
        this.$store.commit('stopLoading');
      });
  }

  clearFilterParams() {
    this.activitylogsevent = 'All';
    this.activityName = 'All';
    this.setupDate(true);
    this.closeMenu();
  }

  handleoutsideClickDate() {
    (this.$refs.containerModalRef as HTMLElement).click();
  }

  reloadData() {
    this.fetchDateFromRequestHeaders();
    this.resetTableConfigs();
    this.clearFilterParams();
  }

  toLoad: number = 50;

  addFilters(filter: any, value: any) {
    this.filters[filter] = value;
  }

  resetTableConfigs() {
    const activityDetails: any[] = [];
    this.$store.commit('ActivityLogsStoreModule/setActivityDetails', activityDetails);
    this.setTotalDataSize(50);
  }

  setTotalDataSize(size: any) {
    this.partialDatasetPaginationConfig = {
      pageNumber: 1,
      pageSize: size,
      datasetOffset: 0,
    };
  }

  updateScroll() {
    try {
      const mainTable = (this.$refs.mainTable as SwTable)?.$el as HTMLElement ?
        (this.$refs.mainTable as SwTable)?.$el as HTMLElement : null;
      if (mainTable) {
        const scrollView = (((this.$refs.mainTable as SwTable).$refs.body as SwTableBody).$refs.bodyCont as HTMLElement);
        scrollView && scrollView.scrollTo(0, +(this.partialDatasetPaginationConfig?.datasetOffset || 0));
      }
    } catch (e) {
      console.error(e);
    }
  }

  async makeTenantIDList(tenantList: any) {
    this.tenantList.clear()
    for ( let i of tenantList) {
      this.tenantList.set(i.tenantName, i.tenantId)
    }
  }

  async makeSerialNumberList(serialList: any) {
    this.serialNumberOptions = serialList.map((item: any) => {
      return {
        id: item.serialNumber.toString(),
        label: item.serialNumber.toString(),
        value: item.serialNumber.toString(),
      }
    });
  }

  async makeTenantList(tenantList: any) {
    this.tenantOptions = tenantList.map((item: any) => {
      return {
        id: item.tenantId.toString(),
        label: item.tenantName.toString(),
        value: item.tenantId.toString(),
      }
    });
  }

  async makeSourceList(sourceList: any) {
    this.sourcesOptions = sourceList.map((item: any) => {
      return {
        id: item.sourceValue.toString(),
        label: item.sourceName.toString(),
        value: item.sourceValue.toString(),
      }
    });
  }

  checkifDateRangeExceedsDays(fromDate: string, toDate: string, days: number) {
    const date1: any = new Date(fromDate);
    const date2: any = new Date(toDate);
    const diffTime: any = Math.abs(date2 - date1);
    const diffDays: any = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays > days) {
      return true;
    }
    return false;
  }

  async makeUsersList(usersList: any) {
    this.usersOptions = usersList.map((item: any) => {
      return {
        id: item.userName.toString(),
        label: item.fullName.toString(),
        value: item.userName.toString(),
      }
    });
  }

  async makeOrganizationsList(organizationsList: any) {
    this.organizationsOptions = organizationsList.map((item: any) => {
      return {
        id: item.organizationId.toString(),
        label: item.organizationName.toString(),
        value: item.organizationId.toString(),
      }
    });
  }

  async makeActivityIpsList(activityIpsList: any) {
    this.activityIpOptions = activityIpsList.map((item: any) => {
      return {
        id: item.activityIp.toString(),
        label: item.activityIp.toString(),
        value: item.activityIp.toString(),
      }
    });
  }

  matchFilterNames(filter: any) {
    switch(filter) {
      case 'operationTypes': return this.activitylogseventoptions;
      case 'organizationsList': return this.organizationsOptions;
      case 'serialList': return this.serialNumberOptions;
      case 'sourceList': return this.sourcesOptions;
      case 'tenantsList': return this.tenantOptions;
      case 'usersList': return this.usersOptions;
      case 'activityIpList': return this.activityIpOptions;
      default: return [];
    }
  }

  makeFilters(filterOptions: any) {
    for(let i in filterOptions) {
      if (this.getFiltertypes.includes(i)) {
        const subFilters = this.matchFilterNames(i) || [];
        if (subFilters.length > 0 || this.isLargeCustomerMode) {
          this.allFilters.push({
            id: i,
            label: i.toUpperCase(),
            value: i,
          });
          if (RADIO_LISTS.includes(i)) {
            this.moreFiltersSelected.set(i, {
              mode: 'radio',
              textField: '',
              radioFilterList: subFilters ? subFilters : [],
              radioSelected: '', }
            );
          } else {
            this.moreFiltersSelected.set(i, {
              mode: 'checkbox',
              textField: '',
              checkboxesSelected: [],
              checkboxFilterList: subFilters ? subFilters : [],
              }
            );
          }
        }
      }
    }
  }

  async makeActivityOperationsData() {
    await this.$store.dispatch('ActivityLogsStoreModule/getActivityOperations', this.$store.getters.getUserId)
      .then((resp) => {
        this.$store.commit('ActivityLogsStoreModule/setActivityOperations', resp.content.filterList.operationTypes);
        this.activityTypeList = resp.content.filterList.operationTypes;
        this.checkboxOptionsList = [];
        this.checkboxOptionsList.push(this.activitylogseventoptions);
        this.isLargeCustomerMode = resp.content.hasOwnProperty('IsFreetypingAllowed') &&
          resp.content.IsFreetypingAllowed === 'YES' ? true : false;
        const { tenantsList, serialList, sourceList, usersList, organizationsList, activityIpList } = resp.content.filterList;
        this.makeTenantIDList(tenantsList);
        this.makeSerialNumberList(serialList);
        this.makeTenantList(tenantsList);
        this.makeSourceList(sourceList);
        this.makeUsersList(usersList);
        this.makeOrganizationsList(organizationsList);
        this.makeActivityIpsList(activityIpList);
        this.makeFilters(resp.content.filterList);
        this.$store.commit('stopLoading');
      });
  }

  setupDate(isfirstTime: boolean = false) {
    this.dtRangeValue =  `${formatDate(this.last30DaysDate.toDateString())}->${formatDate(this.todaysDate.toDateString())}`;
    this.dtRangeValue2 = `${formatDate(this.last30DaysDate.toDateString())}->${formatDate(this.todaysDate.toDateString())}`;
    this.selectableDatesRange = {
      startDate: `${formatDate(this.last1yearDate.toDateString())}`,
      endDate: `${formatDate(this.todaysDate.toDateString())}`,
    };
    if (isfirstTime) {
      this.dateRangeType = 'days30';
      const currentDate = this.dateRangeType === 'custom' ? this.dtRangeValue2 : this.dtRangeValue;
      let fromdate: any = currentDate.split('->')[0].split('/');
      let todate: any = currentDate.split('->')[1].split('/');
      fromdate = `${fromdate[1]}/${fromdate[0]}/${fromdate[2]}`;
      todate = `${todate[1]}/${todate[0]}/${todate[2]}`;
      this.filters['fromdate'] = fromdate;
      this.filters['todate'] = todate;
    }
  }

  setSelectedColumnKeys() {
    this.selectedColumnKeys = this.tableColConfig.map((ele: any) => {
      if (!this.customizedColumnKeys.includes(ele.key)) {
        return ele.key;
      } else {
        return '';
      }
    }).filter((ele) => ele !== '');
  }

  mounted() {
    this.filters['operationType'] = this.selectedActivityType;
    this.filters['operationName'] = this.selectedActivityName;
    this.setTotalDataSize(50);
    this.makeActivityOperationsData();
    this.makeTableData();
    this.handleScroll();
    this.makeTableConfig();
    this.setSelectedColumnKeys();
    this.setupDate(true);
    this.setHelpId('activity-log-help');
  }

  setHelpId(value:string) {
    const temp:string[] = [];
    temp.push(value);
    this.setHelpContentId({ helpId:temp });
  }

  handleScroll() {
    try {
      const mainTable = (this.$refs.mainTable as SwTable).$el as HTMLElement ?
        (this.$refs.mainTable as SwTable).$el as HTMLElement : null;
      if (mainTable) {
        const scrollView = (((this.$refs.mainTable as SwTable).$refs.body as SwTableBody).$refs.bodyCont as HTMLElement);
        scrollView.onscroll = (e: any) => {
          if (e.srcElement && (e.srcElement.scrollHeight - e.srcElement.scrollTop - e.srcElement.clientHeight <= 1)) {
            if (this.tableData.length < this.activityTotalRecords && this.blockScrolling === false) {
              this.isLoadingPartialDataset = true;
              this.partialDatasetPaginationConfig.pageNumber = this.partialDatasetPaginationConfig.pageNumber + 1;
              this.partialDatasetPaginationConfig.datasetOffset = e?.srcElement?.scrollTop || 0;
              this.makeTableData(true);
            }
          }
        };
      }
    } catch (e) {
      console.error(e);
    }
  }
  fetchDateFromRequestHeaders() {
    this.todaysDate = new Date(fetchCurrentDate());
    this.last30DaysDate = new Date(this.todaysDate.getTime() - 30*24*60*60*1000);
    this.last1yearDate = new Date(this.todaysDate.getTime() - 365*24*60*60*1000);
  }
  created() {
    this.fetchDateFromRequestHeaders();
  }
  exportData() {
    ExportcsvService.startExport(this.mapDataForExport(this.getData), 'UserActivity.csv');
  }
  mapDataForExport(data: any[]) {
    let tempArr: any = [];
    const itemHeader: string[] = [];
    this.selectedColumnKeys.forEach((ele: any) => {
      this.tableColConfig.map((entry: any) => {
        if (entry.key === ele) {
          itemHeader.push(entry.title);
        }
      });
    });
    const tempJson: any = [{}, itemHeader];
    data.map((dataItem:any) => {
      const obj = {};
      this.gettableColConfig.forEach((item) => {
        if (item.dataKey) {
          if (item.key === 'actiontime') {
            const date = dataItem[item.dataKey];
            const formattedDate = date;
            // @ts-ignore
            obj[item.title] = formattedDate || '';
          } else {
            // @ts-ignore
            obj[item.title] = `${dataItem[item.dataKey]}` || '';
          }
        }
      });
      tempJson.push(obj);
    });
    tempArr = tempArr.concat(tempJson);
    return tempArr;
  }
}
